/**
 * V70 엔글 마블 V3 — 플레이어 캐릭터 말
 *
 * I3-α 콘셉트:
 *   - 보드게임 말 스타일 (귀여우면서 세련)
 *   - SVG 기반, 벡터 선명도
 *   - 상태별 variant: normal / trapped
 *   - 셀 안에서 작게 (아이콘·라벨 가리지 않음)
 *   - 이동 bounce 애니메이션
 */
import React from 'react';
import './PlayerPawn.css';

export interface PlayerPawnProps {
  size?: number;
  variant?: 'normal' | 'trapped';
  animated?: boolean;
}

export function PlayerPawn({ size = 26, variant = 'normal', animated = true }: PlayerPawnProps) {
  const bodyMain = variant === 'trapped' ? '#9ca3af' : '#fbbf24';
  const bodyDeep = variant === 'trapped' ? '#4b5563' : '#f59e0b';
  const faceColor = variant === 'trapped' ? '#374151' : '#92400e';
  return (
    <div className={`marble-pawn ${animated ? 'bounce' : ''}`} style={{ width: size, height: size }}>
      <svg viewBox="0 0 32 36" width={size} height={size + 4} aria-hidden="true">
        {/* 그림자 */}
        <ellipse cx="16" cy="33" rx="8" ry="1.5" fill="#000" opacity="0.3" />
        {/* 말 몸통 (체스 pawn 형태) */}
        <path
          d="M16 4 Q22 4 22 10 Q22 13 20 15 L22 17 L22 20 L10 20 L10 17 L12 15 Q10 13 10 10 Q10 4 16 4 Z"
          fill={bodyMain}
          stroke={bodyDeep}
          strokeWidth="1.2"
        />
        {/* 아래 받침 */}
        <path d="M8 20 L24 20 L25 24 L23 26 L9 26 L7 24 Z" fill={bodyDeep} stroke={faceColor} strokeWidth="0.8" />
        <ellipse cx="16" cy="27" rx="9" ry="2" fill={bodyMain} stroke={bodyDeep} strokeWidth="0.8" />
        {/* 머리 하이라이트 (3D 느낌) */}
        <ellipse cx="14" cy="8" rx="2" ry="3" fill="#fef3c7" opacity={variant === 'trapped' ? 0.3 : 0.7} />
        {/* 눈 */}
        <circle cx="13" cy="10" r="1" fill="#0f172a" />
        <circle cx="19" cy="10" r="1" fill="#0f172a" />
        {/* 입 */}
        {variant === 'trapped' ? (
          <path d="M13 14 Q16 12 19 14" stroke="#0f172a" strokeWidth="1" fill="none" strokeLinecap="round" />
        ) : (
          <path d="M13 13 Q16 15 19 13" stroke="#0f172a" strokeWidth="1" fill="none" strokeLinecap="round" />
        )}
        {/* 머리 포인터 (방향 표시) */}
        {variant === 'normal' && (
          <polygon points="16,1 13,4 19,4" fill="#f472b6" stroke="#be185d" strokeWidth="0.5" />
        )}
        {variant === 'trapped' && (
          <circle cx="16" cy="3" r="2" fill="none" stroke="#dc2626" strokeWidth="1" />
        )}
      </svg>
    </div>
  );
}

export default PlayerPawn;
